import { render } from "./StarOverlay.vue?vue&type=template&id=75f381a1&scoped=true"
const script = {}

import "./StarOverlay.vue?vue&type=style&index=0&id=75f381a1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aa\\Desktop\\Client-files\\BB\\BB_Web\\bb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f381a1"]])

export default __exports__